import { render, staticRenderFns } from "./promiseDetail.vue?vue&type=template&id=55844276&scoped=true"
import script from "./promiseDetail.vue?vue&type=script&lang=js"
export * from "./promiseDetail.vue?vue&type=script&lang=js"
import style0 from "./promiseDetail.vue?vue&type=style&index=0&id=55844276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55844276",
  null
  
)

export default component.exports